import axios from "axios";

type TabelaFipeReferencia = {
	Codigo: number;
	Mes: string;
  };

const ExternalClient = axios.create({
	baseURL: 'https://veiculos.fipe.org.br/api/veiculos/',

});

export const getTabelaFipeReferencia = async (): Promise<TabelaFipeReferencia | undefined> => {
 
	try {
		const response = await ExternalClient.post<TabelaFipeReferencia[]>('ConsultarTabelaDeReferencia').then((response) => response.data);

		if (response && response.length > 0) {
			const lastReference = response[0];
			return {
				Codigo: lastReference.Codigo,
				Mes: lastReference.Mes
			};
		}
  
	  return undefined;
	} catch (error) {
	  console.error('Erro buscando referencia fipe:', error);
	}
};
